// ** React Imports
import React from 'react'

// ** Source code Imports
import CookiesPolicyRu from './cookie-policy-ru'

const CookiesPolicy = () => {
  return <CookiesPolicyRu />
}

export default CookiesPolicy
